
export default {
    name: "popup_placard_info",
    props: ["item"],
    data(){
        return {

        }
    },
    computed: {
        badge(){
            const key = `${ this.item.key }`;

            if(this.item.zone == "peacetopia"){
                return { label: "Words to live by", icon: "peacetopia", color: "#B6629C" };
            }

            if(key.startsWith("stall_")){
                return { label: "Nutrition Tip", icon: "orchard_stall", color: "#009383" };
            }

            return { label: `Swim Tip ${ key } of ${ this.item.total }`, icon: "orchard_swim", color: "#00ADD9" };
        },
    },
    mounted(){

    },
    methods: {
        onClickCloseBtn(){
            this.$emit("update:item", null);
            this.onHandleTriggerAnalytics(`close@placard@${ this.item.zone }@${ this.item.key }`);
        },
    },
}
